export * from '@netx/core-user-next/constants';

export const USER_LEVEL = <const>{
	NO_ACCESS: 0,
	BROWSER: 1,
	CONSUMER: 2,
	IMPORTER: 3,
	PRODUCER: 4,
	MANAGER: 7,
	DIRECTOR: 8,
	ADMIN: 9,
};
